import { removeFromArray, mergeInArray } from '../utils'
import {
  CREATE_ALERT_SUCCESS,
  CREATE_FAVORITE_SUCCESS,
  DELETE_ALERT_SUCCESS,
  DELETE_FAVORITE_SUCCESS,
  FETCH_ALERTS_SUCCESS,
  FETCH_FAVORITE_PROPERTY_SUCCESS,
  FETCH_FAVORITES_SUCCESS,
  FETCH_OFFERS_SUCCESS,
  FETCH_TOURS_SUCCESS,
  RESET_FAVORITE_PROPERTIES,
  UPDATE_ALERT_SUCCESS,
  UPDATE_PROFILE_FAILURE,
  UPDATE_PROFILE_SUCCESS
} from '../constants'

const initialState = {
  errors: {},
  favorites: [],
  favoriteProperties: [],
  tours: [],
  offers: [],
  alerts: []
}

export default function(state = initialState, action) {
  switch (action.type) {
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        errors: {}
      }
    case UPDATE_PROFILE_FAILURE:
      return {
        ...state,
        errors: action.errors
      }
    case CREATE_FAVORITE_SUCCESS:
      return {
        ...state,
        favorites: [...state.favorites, action.favorite]
      }
    case FETCH_FAVORITES_SUCCESS:
      return {
        ...state,
        favorites: action.favorites
      }
    case DELETE_FAVORITE_SUCCESS: {
      const index = state.favorites
        .map((favorite) => favorite.id)
        .indexOf(action.favorite.id)
      return {
        ...state,
        favorites: removeFromArray(state.favorites, index)
      }
    }
    case FETCH_FAVORITE_PROPERTY_SUCCESS: {
      return {
        ...state,
        favoriteProperties: [...state.favoriteProperties, action.property]
      }
    }
    case RESET_FAVORITE_PROPERTIES:
      return {
        ...state,
        favoriteProperties: []
      }
    case FETCH_TOURS_SUCCESS:
      return {
        ...state,
        tours: action.tours
      }
    case FETCH_OFFERS_SUCCESS:
      return {
        ...state,
        offers: action.offers
      }
    case FETCH_ALERTS_SUCCESS:
      return {
        ...state,
        alerts: action.alerts
      }
    case CREATE_ALERT_SUCCESS:
      return {
        ...state,
        alerts: [...state.alerts, action.alert]
      }
    case UPDATE_ALERT_SUCCESS: {
      const index = state.alerts
        .map((alert) => alert.id)
        .indexOf(action.alert.id)
      return {
        ...state,
        alerts: mergeInArray(state.alerts, index, action.alert)
      }
    }
    case DELETE_ALERT_SUCCESS: {
      const index = state.alerts
        .map((alert) => alert.id)
        .indexOf(action.alert.id)
      return {
        ...state,
        alerts: removeFromArray(state.alerts, index)
      }
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.js